import emptyTransactions from '@/assets/lotties/empty_state.json';
import loadingError from '@/assets/lotties/payment_failure.json';

export const EVENTS = {
  ADS: {
    LIST_ALL: {
      REFRESH: 'ADS.LIST_ALL.REFRESH',
      REFRESHING: 'ADS.LIST_ALL.REFRESHING',
      REFRESHED: 'ADS.LIST_ALL.REFRESHED',
      REFRESH_ERROR: 'ADS.LIST_ALL.REFRESH_ERROR'
    }
  }
};

export const ENDPOINTS = {
  ADS: {
    GET_LIST: '/store/app/data?service=1xpay&userId=1xpay-ads&group=lacasae',
    UPDATE: '/store/app/data?service=1xpay&userId=1xpay-ads&group=lacasae'
  }
};

export const ADS = {
  LOTTIES: {
    EMPTY: emptyTransactions,
    LOADING_ERROR: loadingError
  }
};
